import { render, staticRenderFns } from "./BillingSummary.vue?vue&type=template&id=e8837522&scoped=true&"
import script from "./BillingSummary.vue?vue&type=script&lang=js&"
export * from "./BillingSummary.vue?vue&type=script&lang=js&"
import style0 from "./BillingSummary.vue?vue&type=style&index=0&id=e8837522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8837522",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8837522')) {
      api.createRecord('e8837522', component.options)
    } else {
      api.reload('e8837522', component.options)
    }
    module.hot.accept("./BillingSummary.vue?vue&type=template&id=e8837522&scoped=true&", function () {
      api.rerender('e8837522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/billing/BillingSummary.vue"
export default component.exports